{
  "distribution.new_tab": "opent in nieuw tabblad",

  "distribution.revision_generation": "r{revision} · generatie {generation}",

  "distribution.website.title": "Website",
  "distribution.website.site": "Website kiezen",
  "distribution.website.empty_title": "Nog geen website",
  "distribution.website.empty_body": "Voor deze organisatie is nog geen site ingericht.",
  "distribution.website.base_locale": "Brontaal {locale}",
  "distribution.website.live_locales": "{count, plural, =0 {nog geen taal live} one {# taal live} other {# talen live}}",
  "distribution.website.open_site": "Site bekijken",
  "distribution.website.channels": "Kanalen van deze website",

  "distribution.channel.last_failed": "Laatste build mislukt",
  "distribution.channel.not_published": "Niet gepubliceerd",
  "distribution.channel.open_live": "Live site openen",
  "distribution.channel.open_preview": "Preview openen",
  "distribution.channel.locales": "Talen",
  "distribution.channel.unreviewed": "ongereviewd",
  "distribution.channel.gone_count": "{count, plural, one {# pad geeft 410} other {# paden geven 410}}",
  "distribution.channel.none_production": "Nog niets gepubliceerd naar productie.",
  "distribution.channel.none_preview": "Nog geen preview. Publiceer naar preview om de site met alle talen intern te bekijken.",
  "distribution.channel.live": "Live",
  "distribution.channel.hint_production": "Voor bezoekers, alleen gereviewde talen",
  "distribution.channel.hint_preview": "Intern, ook ongereviewde talen",
  "distribution.channel.live_since": "live sinds",
  "distribution.channel.no_host": "Geen domein gekoppeld",
  "distribution.channel.unreviewed_title": "{locale}, ongereviewd: alleen in preview",
  "distribution.channel.unreviewed_count": "{count} ongereviewd",
  "distribution.channel.failed_note": "Build r{revision} is mislukt; de vorige versie blijft live.",
  "distribution.channel.view_build": "Build bekijken",

  "distribution.strategy.full": "Volledig",
  "distribution.strategy.delta": "Delta (alleen wijzigingen)",
  "distribution.strategy.emergency_withdrawal": "Spoedintrekking",

  "distribution.publish.action": "Publiceren",
  "distribution.publish.to_production": "Naar productie",
  "distribution.publish.to_preview": "Naar preview",
  "distribution.publish.title": "Website publiceren",
  "distribution.publish.channel": "Kanaal",
  "distribution.publish.preview_hint": "Intern bekijken, met alle talen, ook ongereviewde.",
  "distribution.publish.production_hint": "Live voor bezoekers, alleen gepubliceerde talen.",
  "distribution.publish.reason": "Reden",
  "distribution.publish.reason_hint": "Komt in de publicatiegeschiedenis.",
  "distribution.publish.production_notice_title": "Gaat live voor bezoekers",
  "distribution.publish.production_notice": "Bezoekers zien deze versie zodra de build klaar is en alle releasecontroles slagen. Faalt een controle, dan blijft de huidige versie staan.",
  "distribution.publish.submit_preview": "Naar preview publiceren",
  "distribution.publish.submit_production": "Naar productie publiceren",
  "distribution.publish.started": "Publicatie r{revision} gestart",
  "distribution.publish.started_body": "{channel}: de build staat in de wachtrij.",
  "distribution.publish.locales": "Talen: {locales}",

  "distribution.counts.properties": "Woningen",
  "distribution.counts.excluded": "Uitgesloten",

  "distribution.excluded.show_all": "Alle {count} woningen tonen",
  "distribution.excluded.show_less": "Minder tonen",
  "distribution.excluded.none": "Geen woningen uitgesloten.",
  "distribution.excluded.no_website_right": "Geen websiterecht",
  "distribution.excluded.text_missing_or_unreviewed": "Tekst ontbreekt of is niet gereviewd",
  "distribution.excluded.stale_fact_conflict": "Tekst spreekt de feiten tegen",
  "distribution.excluded.no_publishable_cover": "Geen publiceerbare hoofdfoto",

  "distribution.builds.was_live": "Eerder live",

  "distribution.build.title": "Build r{revision} · generatie {generation}",
  "distribution.build.auto_refresh": "Ververst vanzelf",
  "distribution.build.facts": "Gegevens",
  "distribution.build.queued": "In wachtrij",
  "distribution.build.finished": "Klaar",
  "distribution.build.wait": "Wachttijd",
  "distribution.build.pages": "Pagina's",
  "distribution.build.files": "{count, plural, one {# bestand} other {# bestanden}}",
  "distribution.build.size": "Grootte",
  "distribution.build.log": "Logfragment",
  "distribution.build.no_log": "Geen logfragment beschikbaar voor deze build.",
  "distribution.build.duration": "Duur",
  "distribution.build.strategy": "Opbouw",
  "distribution.build.by": "Door",
  "distribution.build.reason": "Reden",
  "distribution.build.release": "Release",
  "distribution.build.code": "Code",
  "distribution.build.excluded": "{count, plural, one {# woning uitgesloten} other {# woningen uitgesloten}}",
  "distribution.build.log_pending": "Het logfragment volgt als de build klaar is.",

  "distribution.checks.title": "Releasecontroles",
  "distribution.checks.ok": "Geslaagd",
  "distribution.checks.failed": "Afgekeurd",
  "distribution.checks.failed_count": "{count} van {total} afgekeurd",
  "distribution.checks.passed_count": "{count, plural, one {# controle geslaagd} other {alle # controles geslaagd}}",
  "distribution.checks.more": "en nog {count}",
  "distribution.checks.none": "Geen controles vastgelegd.",
  "distribution.checks.pending": "Controles volgen als de build klaar is.",

  "distribution.check.private_data": "Geen privégegevens",
  "distribution.check.html_basics": "HTML-basis",
  "distribution.check.internal_links": "Interne links",
  "distribution.check.hreflang_reciprocity": "Taalverwijzingen (hreflang)",
  "distribution.check.sitemap": "Sitemap",
  "distribution.check.locales": "Startpagina per taal",
  "distribution.check.no_fixture_in_production": "Geen ongereviewde testteksten live",
  "distribution.check.budgets": "Groottebudget",

  "distribution.releases.rollback": "Terugzetten",
  "distribution.releases.confirm_body": "Iedereen ziet direct deze release. Spoedintrekkingen blijven van kracht: ingetrokken woningen komen niet terug.",
  "distribution.releases.confirm": "Naar r{revision} terugzetten",
  "distribution.releases.rolled_back": "{channel} teruggezet naar r{revision}",
  "distribution.releases.empty_title": "Nog geen releases",
  "distribution.releases.empty_body": "Na de eerste productiepublicatie staan de releases hier.",
  "distribution.releases.title": "Terugzetten",
  "distribution.releases.channel": "Kanaal",
  "distribution.releases.rollback_to": "Terugzetten naar r{revision}, generatie {generation}",
  "distribution.releases.confirm_title_production": "Productie terugzetten naar r{revision}?",
  "distribution.releases.confirm_title_preview": "Preview terugzetten naar r{revision}?",
  "distribution.releases.built": "Gebouwd",
  "distribution.releases.empty_production": "Na de eerste productiepublicatie kun je hier terugzetten.",
  "distribution.releases.empty_preview": "Na de eerste previewpublicatie kun je hier terugzetten.",
  "distribution.releases.show_all": "Alle {count} tonen",
  "distribution.releases.show_less": "Minder tonen",

  "distribution.withdrawals.lead": "Haal een woning direct van de live site, zonder op een build te wachten. Voor een vervallen recht of een verzoek van de eigenaar.",
  "distribution.withdrawals.action": "Woning intrekken",
  "distribution.withdrawals.no_rights": "Alleen eigenaren en beheerders kunnen een woning direct intrekken.",
  "distribution.withdrawals.processing": "Intrekking van {reference} wordt verwerkt",
  "distribution.withdrawals.processing_body": "De achtergrondtaak past de live site aan; deze lijst ververst vanzelf.",
  "distribution.withdrawals.removed": "{count, plural, one {# pagina verwijderd} other {# pagina's verwijderd}}",
  "distribution.withdrawals.gone_title": "Paden met 410 (Gone)",
  "distribution.withdrawals.gone_body": "De live site geeft voor deze paden 410, ook als een oudere release ze nog bevat. Zoekmachines halen ze daardoor uit de index.",
  "distribution.withdrawals.title": "Spoedintrekking",
  "distribution.withdrawals.gone_count": "{count, plural, one {# pad geeft 410} other {# paden geven 410}}",

  "distribution.withdrawal_status.pending": "Wordt uitgevoerd",
  "distribution.withdrawal_status.applied": "Uitgevoerd",
  "distribution.withdrawal_status.failed": "Mislukt",

  "distribution.withdraw.title": "Woning direct van de website halen",
  "distribution.withdraw.description": "Spoedintrekking op alle sites van deze organisatie.",
  "distribution.withdraw.property": "Woning",
  "distribution.withdraw.property_placeholder": "Zoek op referentie",
  "distribution.withdraw.property_hint": "Alleen woningen met een geldig websiterecht.",
  "distribution.withdraw.reason": "Reden",
  "distribution.withdraw.reason_hint": "Verplicht, minstens 3 tekens. Komt in het auditlog en bij het ingetrokken recht.",
  "distribution.withdraw.effects_title": "Wat er direct gebeurt",
  "distribution.withdraw.effect_live": "De woningpagina's verdwijnen in alle talen uit productie en preview, en uit zoekindex en sitemap.",
  "distribution.withdraw.effect_410": "De oude adressen geven 410 (Gone).",
  "distribution.withdraw.effect_right": "Het websiterecht van de woning wordt ingetrokken.",
  "distribution.withdraw.effect_publish": "Daarna volgt automatisch een nieuwe productiepublicatie zonder de woning.",
  "distribution.withdraw.confirm": "Ik begrijp dat dit direct live gaat",
  "distribution.withdraw.confirm_named": "Ik begrijp dat {reference} direct van de live site verdwijnt",
  "distribution.withdraw.submit": "Direct intrekken",
  "distribution.withdraw.started": "Intrekking van {reference} gestart",
  "distribution.withdraw.started_body": "Volg het resultaat bij Eerdere intrekkingen.",
  "distribution.withdraw.submit_named": "{reference} direct intrekken",

  "distribution.channels.title": "Portalen",
  "distribution.channels.lead": "Een gegenereerde of opgehaalde feed betekent nog niet dat een portaal je woningen toont.",
  "distribution.channels.accounts": "Kanalen van deze organisatie",
  "distribution.channels.registry": "Overige portalen in het register",
  "distribution.channels.col_channel": "Kanaal",
  "distribution.channels.col_evidence": "Bewijs BRES",
  "distribution.channels.col_missing": "Nog nodig",
  "distribution.channels.simulated": "Gesimuleerd",
  "distribution.channels.priority": "Prioriteit {priority}",
  "distribution.channels.no_adapter": "Geen adapter",
  "distribution.channels.empty_title": "Geen kanalen",
  "distribution.channels.empty_body": "Er zijn nog geen portaalaccounts voor deze organisatie.",
  "distribution.channels.kill_switch_on": "Noodstop aan",
  "distribution.channels.kill_switch_notice": "Er gaan geen feeds of pushes naar dit kanaal tot je de noodstop uitzet.",
  "distribution.channels.no_account_title": "Geen account",
  "distribution.channels.no_account": "Deze organisatie heeft geen account bij dit kanaal. Hieronder staat hoe ver BRES is en wat er nog nodig is.",
  "distribution.channels.missing_title": "Nog nodig",
  "distribution.channels.missing_none": "Niets openstaand voor BRES als product.",
  "distribution.channels.docs": "Bronnen",
  "distribution.channels.owner": "Eigenaar: {owner}",
  "distribution.channels.and_more": "en {count} meer",
  "distribution.channels.count": "{count, plural, one {# kanaal} other {# kanalen}}",
  "distribution.channels.listings": "woningen",
  "distribution.channels.listings_of": "woningen, limiet {limit}",
  "distribution.channels.last_feed": "laatste feed",
  "distribution.channels.delivery": "levering",
  "distribution.channels.push_test": "Testpush",
  "distribution.channels.rejected": "afgewezen",
  "distribution.channels.test_note": "Testadapter op deze computer. Er gaat niets naar een extern portaal.",
  "distribution.channels.no_adapter_note": "BRES levert nog niets aan {name}. De mogelijke routes staan bij Bewijs.",
  "distribution.channels.feed_note": "Feed klaar om op te halen. {name} heeft nog niets opgehaald of geaccepteerd.",
  "distribution.channels.fetched_note": "{name} haalt de feed op. Ophalen is nog geen acceptatie.",
  "distribution.channels.detail_tabs": "Onderdelen van dit kanaal",
  "distribution.channels.tab_delivery": "Levering",
  "distribution.channels.tab_evidence": "Bewijs",
  "distribution.channels.tab_settings": "Instellingen",
  "distribution.channels.no_adapter_title": "Nog geen adapter",
  "distribution.channels.no_adapter_body": "BRES stuurt niets naar {name}. Bij Bewijs staat wat er nodig is.",

  "distribution.kind.portal": "Portaal",
  "distribution.kind.aggregator": "Aggregator",
  "distribution.kind.crm": "CRM",
  "distribution.kind.source": "Bron",
  "distribution.kind.internal": "BRES-formaat",
  "distribution.kind.test": "Testadapter",

  "distribution.evidence.title": "Bewijsniveau",
  "distribution.evidence.ladder": "Bewijsniveaus van laag naar hoog",
  "distribution.evidence.marker_product": "BRES",
  "distribution.evidence.marker_account": "Dit account",
  "distribution.evidence.candidate": "Kandidaat",
  "distribution.evidence.awaiting_contract": "Wacht op contract",
  "distribution.evidence.documented": "Gedocumenteerd",
  "distribution.evidence.implemented": "Gebouwd",
  "distribution.evidence.contract_tested": "Contract getest",
  "distribution.evidence.sandbox_accepted": "Geaccepteerd in testomgeving",
  "distribution.evidence.production_enabled": "Actief in productie",
  "distribution.evidence.degraded": "Verstoord",
  "distribution.evidence.paused": "Gepauzeerd",
  "distribution.evidence.mini_label": "Dit account: {account}. BRES: {product}.",

  "distribution.evidence_hint.candidate": "Bekeken als optie; geen specificatie of contract.",
  "distribution.evidence_hint.awaiting_contract": "Toegang of specificatie moet nog van de partij komen.",
  "distribution.evidence_hint.documented": "Specificatie bekend; nog geen adapter in BRES.",
  "distribution.evidence_hint.implemented": "Adapter bestaat in BRES; niet getoetst aan een officieel schema.",
  "distribution.evidence_hint.contract_tested": "Lokaal gevalideerd tegen het officiële schema. Het portaal heeft niets ontvangen.",
  "distribution.evidence_hint.sandbox_accepted": "Het portaal heeft listings geaccepteerd in een testomgeving.",
  "distribution.evidence_hint.production_enabled": "Extern bewijs: het portaal accepteert listings van dit account.",
  "distribution.evidence_hint.degraded": "Werkte, maar geeft nu fouten. Bekijk de leverstatus per woning.",
  "distribution.evidence_hint.paused": "Bewust stilgezet; er gaat niets naar dit kanaal.",

  "distribution.cap.title": "Wat het kanaal kan",
  "distribution.cap.transport": "Levering",
  "distribution.cap.transport_pull_snapshot": "Feed die het portaal ophaalt",
  "distribution.cap.transport_push_api": "Push via API",
  "distribution.cap.transport_file": "Bestand",
  "distribution.cap.transport_webhook": "Webhook",
  "distribution.cap.transport_unknown": "Nog onbekend",
  "distribution.cap.receipt": "Terugmelding",
  "distribution.cap.receipt_none": "Geen",
  "distribution.cap.receipt_fetched": "Alleen dat de feed is opgehaald",
  "distribution.cap.receipt_accepted": "Acceptatie per listing",
  "distribution.cap.receipt_listing_status": "Status per listing",
  "distribution.cap.receipt_unknown": "Nog onbekend",
  "distribution.cap.deletion": "Intrekken",
  "distribution.cap.deletion_explicit": "Expliciete intrekking",
  "distribution.cap.deletion_missing_in_complete_snapshot": "Weglaten uit de volledige feed",
  "distribution.cap.deletion_unsupported": "Niet ondersteund",
  "distribution.cap.deletion_unknown": "Nog onbekend",
  "distribution.cap.reconciliation": "Externe stand vergelijken",
  "distribution.cap.locales": "Talen",
  "distribution.cap.locales_contract_defined": "Volgens contract",
  "distribution.cap.locales_unknown": "Nog onbekend",
  "distribution.cap.verified": "Gecontroleerd op",

  "distribution.route.title": "Mogelijke routes",
  "distribution.route.lead": "Voor {name} is geen openbaar publicatiecontract beschikbaar. Er zijn drie routes; er is nog geen gekozen en BRES stuurt nu niets naar {name}.",
  "distribution.route.a_title": "Direct partnerschap",
  "distribution.route.a_body": "BRES wordt softwarepartner met eigen publicatietoegang, eigen terugmeldingen en vergelijking van de externe stand.",
  "distribution.route.a_condition": "Voorwaarde: acceptatie als partner. Doorlooptijd en kosten zijn onbekend.",
  "distribution.route.b_title": "Publicatiepartner",
  "distribution.route.b_body": "Een partij met bestaande toegang levert namens BRES.",
  "distribution.route.b_condition": "Voorwaarde: vastleggen wie wijzigingen beheert en welke statussen terugkomen. Extra kosten.",
  "distribution.route.c_title": "Klant-CRM blijft publiceren",
  "distribution.route.c_body": "Het bestaande CRM van de makelaar bedient het portaal; BRES importeert voor website en talen.",
  "distribution.route.c_condition": "Gevolg: BRES belooft dan geen publicatie op dit portaal. Bronhouder per veld vastleggen.",
  "distribution.route.decision": "De keuze valt bij de pilotintake, vóór een offerte waarin {name} wordt beloofd. Pas daarna volgen specificatie, sandbox, adapter en acceptatie.",

  "distribution.feed.title": "Feed",
  "distribution.feed.generate": "Feed genereren en valideren",
  "distribution.feed.generated": "{count, plural, one {Feed gemaakt met # woning} other {Feed gemaakt met # woningen}}",
  "distribution.feed.generated_invalid": "Feed ongeldig; de vorige feed blijft staan",
  "distribution.feed.not_accepted": "Gegenereerd en lokaal gevalideerd. {name} heeft deze feed niet opgehaald of geaccepteerd.",
  "distribution.feed.fetched": "{name} heeft de feed opgehaald op {time}. Ophalen is nog geen acceptatie van de woningen.",
  "distribution.feed.valid_title": "{count, plural, one {# woning voldoet aan het schema} other {# woningen voldoen aan het schema}}",
  "distribution.feed.schema_kyero": "Gevalideerd tegen de officiële Kyero XSD v3.0.",
  "distribution.feed.schema_jamesedition": "Gevalideerd tegen een eigen schema op basis van de openbare JamesEdition-documentatie v3.9; een officieel schema bestaat niet.",
  "distribution.feed.invalid_title": "Feed voldoet niet aan het schema",
  "distribution.feed.invalid_body": "Deze feed is niet live gezet. De vorige geldige feed blijft beschikbaar.",
  "distribution.feed.in_feed": "In feed",
  "distribution.feed.errors": "Fouten",
  "distribution.feed.warnings": "Waarschuwingen",
  "distribution.feed.created": "Gemaakt",
  "distribution.feed.state": "Stand",
  "distribution.feed.revision": "Websiterevisie",
  "distribution.feed.hash": "SHA-256",
  "distribution.feed.issues": "Meldingen per woning",
  "distribution.feed.view": "Feed bekijken",
  "distribution.feed.download": "XML downloaden",
  "distribution.feed.none": "Nog geen feed gemaakt. Genereer er een uit de laatste productiepublicatie.",
  "distribution.feed.none_short": "Nog geen feed",
  "distribution.feed.valid_short": "Geldig",
  "distribution.feed.invalid_short": "Ongeldig",
  "distribution.feed.blocked_kill_switch": "De noodstop staat aan; er wordt geen feed gemaakt.",

  "distribution.artifact.live": "Actuele feed",
  "distribution.artifact.valid": "Geldig",
  "distribution.artifact.invalid": "Ongeldig",
  "distribution.artifact.superseded": "Vervangen",

  "distribution.delivery.generated": "In feed gezet",
  "distribution.delivery.sent": "Verzonden",
  "distribution.delivery.fetched": "Opgehaald",
  "distribution.delivery.accepted": "Geaccepteerd door portaal",
  "distribution.delivery.accepted_test": "Geaccepteerd door testadapter",
  "distribution.delivery.rejected": "Afgewezen",
  "distribution.delivery.withdrawn": "Ingetrokken",
  "distribution.delivery.unknown": "Onbekend",

  "distribution.listings.title": "Leverstatus per woning",
  "distribution.listings.lead": "Wat BRES per woning weet. “In feed gezet” betekent: in de gegenereerde feed, nog niet geplaatst.",
  "distribution.listings.lead_test": "Uitkomsten van de testadapter. Gesimuleerd; er is geen extern portaal.",
  "distribution.listings.limit": "Listinglimiet",
  "distribution.listings.empty_title": "Nog geen leveringen",
  "distribution.listings.col_property": "Woning",
  "distribution.listings.col_status": "Status",
  "distribution.listings.col_external": "Externe ID",
  "distribution.listings.col_reason": "Reden",
  "distribution.listings.col_delivered": "Laatste levering",
  "distribution.listings.search": "Woningen in dit kanaal zoeken",
  "distribution.listings.search_placeholder": "Referentie of titel",
  "distribution.listings.all_statuses": "Alle ({count})",
  "distribution.listings.clear": "Filters wissen",
  "distribution.listings.empty_filtered_title": "Geen woningen met dit filter",
  "distribution.listings.empty_filtered_body": "Wis de filters om alle leveringen te zien.",
  "distribution.listings.empty_body_feed": "Genereer een feed; per woning verschijnt hier de status.",
  "distribution.listings.empty_body_test": "Verstuur een testpush; de uitkomst per woning verschijnt hier.",
  "distribution.listings.empty_body_none": "Zonder adapter levert BRES niets aan dit kanaal.",
  "distribution.listings.more": "Nog {count} laden",

  "distribution.test.title": "Testpush",
  "distribution.test.notice_title": "Lokale testadapter",
  "distribution.test.notice": "Simuleert een push-portaal op deze computer: idempotentie, time-outs, rate limits en afwijzingen. Er gaat niets naar een extern portaal.",
  "distribution.test.property": "Woning",
  "distribution.test.fault": "Fout simuleren",
  "distribution.test.push": "Testpush versturen",
  "distribution.test.reconcile": "Reconciliëren",
  "distribution.test.result_accepted": "Geaccepteerd door testadapter",
  "distribution.test.result_reconciled": "Na time-out teruggevonden",
  "distribution.test.result_unknown": "Uitkomst onbekend",
  "distribution.test.result_rate_limited": "Rate limit bereikt",
  "distribution.test.result_rejected": "Afgewezen door testadapter",
  "distribution.test.explain_accepted": "Gesimuleerde acceptatie. De externe ID is vastgelegd; een volgende push werkt dezelfde listing bij.",
  "distribution.test.explain_reconciled": "Het antwoord bleef uit, maar de listing bestond al. BRES heeft de externe ID overgenomen in plaats van een dubbele aan te maken.",
  "distribution.test.explain_unknown": "Er kwam geen antwoord en de listing is niet teruggevonden. Reconcilieer voordat je opnieuw pusht.",
  "distribution.test.explain_rate_limited": "De adapter vroeg om later opnieuw te proberen. De status staat op onbekend tot een volgende poging of reconciliatie.",
  "distribution.test.explain_rejected": "De adapter weigerde de listing. De melding staat bij de woning in de leverstatus.",
  "distribution.test.external_id": "Externe ID {id}",
  "distribution.test.reconciled": "{count, plural, =0 {Geen listings komen overeen} one {# listing komt overeen} other {# listings komen overeen}}",
  "distribution.test.missing_remote": "{count, plural, =0 {Niets ontbreekt bij de testadapter} one {# ontbreekt bij de testadapter} other {# ontbreken bij de testadapter}}",
  "distribution.test.unknown_remote": "{count, plural, =0 {Geen onbekende listings bij de testadapter} one {# onbekende listing bij de testadapter} other {# onbekende listings bij de testadapter}}",

  "distribution.fault.none": "Geen fout",
  "distribution.fault.timeout_after_commit": "Time-out na vastleggen",
  "distribution.fault.rate_limited": "Rate limit (429)",
  "distribution.fault.reject": "Afwijzing",

  "distribution.fault_hint.none": "De testadapter accepteert de listing.",
  "distribution.fault_hint.timeout_after_commit": "De listing wordt opgeslagen, maar het antwoord blijft uit. BRES controleert eerst de externe stand in plaats van opnieuw aan te maken.",
  "distribution.fault_hint.rate_limited": "De adapter weigert tijdelijk met 429; de status wordt onbekend.",
  "distribution.fault_hint.reject": "De adapter weigert de listing met een foutmelding.",

  "distribution.settings_form.status": "Accountstatus",
  "distribution.settings_form.status_hint": "Niveaus boven het bewijs van BRES, en acceptatie door het portaal, zet je niet met de hand. Die vragen extern bewijs.",
  "distribution.settings_form.limit": "Listinglimiet",
  "distribution.settings_form.limit_hint": "Maximaal aantal woningen in de feed, als je pakket bij het portaal dat begrenst.",
  "distribution.settings_form.note": "Toelichting",
  "distribution.settings_form.kill_switch": "Noodstop",
  "distribution.settings_form.kill_switch_hint": "Stopt het maken van feeds en pushes naar dit kanaal.",
  "distribution.settings_form.no_rights": "Alleen eigenaren en beheerders wijzigen kanalen.",
  "distribution.settings_form.saved": "{name} bijgewerkt",
  "distribution.settings_form.note_hint": "Leeg laten en opslaan wist de toelichting.",
  "distribution.settings_form.changes": "{count, plural, one {# wijziging} other {# wijzigingen}}",
  "distribution.settings_form.discard": "Wijzigingen weggooien",
  "distribution.settings_form.no_rights_title": "Alleen-lezen",

  "distribution.issue.schema": "Schemafout",
  "distribution.issue.timeout": "Time-out; uitkomst onbekend",
  "distribution.issue.channel.listing_limit_reached": "Buiten de listinglimiet",
  "distribution.issue.kyero.type_not_supported": "Woningsoort niet ondersteund door Kyero",
  "distribution.issue.kyero.offer_kind_not_supported": "Vakantieverhuur niet ondersteund door Kyero",
  "distribution.issue.kyero.price_on_request_not_supported": "Prijs op aanvraag niet toegestaan",
  "distribution.issue.kyero.currency_not_supported": "Valuta niet ondersteund",
  "distribution.issue.kyero.price_too_long": "Prijs te lang voor het formaat",
  "distribution.issue.kyero.location_incomplete": "Plaats of provincie ontbreekt",
  "distribution.issue.kyero.no_images": "Geen bruikbare foto's",
  "distribution.issue.jamesedition.type_not_supported": "Woningsoort niet ondersteund door JamesEdition",
  "distribution.issue.jamesedition.holiday_let_not_supported": "Vakantieverhuur niet ondersteund",
  "distribution.issue.jamesedition.city_missing": "Plaats ontbreekt",
  "distribution.issue.jamesedition.min_two_images": "Minstens twee foto's nodig",
  "distribution.issue.kyero.unknown_type": "Onbekende woningsoort",
  "distribution.issue.kyero.unknown_price_freq": "Onbekende prijsfrequentie",
  "distribution.issue.kyero.unknown_language": "Onbekende taalcode",
  "distribution.issue.kyero.unknown_country": "Onbekend land",
  "distribution.issue.kyero.unexpected_version": "Onverwachte feedversie",
  "distribution.issue.kyero.no_root": "Geen geldig Kyero-bestand",
  "distribution.issue.kyero.no_interpreted_as_nb": "Taalcode no gelezen als Noors (nb)",
  "distribution.issue.kyero.missing_id": "Woning zonder ID overgeslagen",
  "distribution.issue.kyero.invalid_price": "Ongeldige prijs",
  "distribution.issue.kyero.invalid_currency": "Ongeldige valuta",
  "distribution.issue.json.schema": "Bestand wijkt af van het BRES JSON-schema",
  "distribution.issue.json.property_schema": "Woning wijkt af van het schema",
  "distribution.issue.json.invalid": "Geen geldige JSON",
  "distribution.issue.csv.missing_external_id": "Rij zonder externe ID",
  "distribution.issue.csv.missing_columns": "Verplichte kolommen ontbreken",
  "distribution.issue.csv.ambiguous_amount": "Bedrag is niet eenduidig",
  "distribution.issue.import.invalid_reference": "Ongeldige referentie",
  "distribution.issue.import.invalid_kind": "Ongeldige woningsoort",
  "distribution.issue.import.invalid_offer_kind": "Ongeldige soort aanbod",
  "distribution.issue.import.invalid_currency": "Ongeldige valuta",
  "distribution.issue.import.price_missing": "Prijs ontbreekt",
  "distribution.issue.import.price_not_positive": "Prijs moet groter dan nul zijn",
  "distribution.issue.import.country_missing": "Land ontbreekt",
  "distribution.issue.import.locality_missing": "Plaats ontbreekt",
  "distribution.issue.import.area_implausible": "Oppervlakte onwaarschijnlijk",
  "distribution.issue.import.bedrooms_implausible": "Aantal slaapkamers onwaarschijnlijk",
  "distribution.issue.import.bedrooms_for_non_dwelling": "Slaapkamers bij een niet-woning",
  "distribution.issue.import.unknown_features": "Onbekende kenmerken genegeerd",
  "distribution.issue.import.duplicate_external_id": "Externe ID komt dubbel voor",
  "distribution.issue.import.reference_exists_unlinked": "Referentie bestaat al in BRES, maar komt niet uit deze bron",
  "distribution.issue.import.missing_in_complete_snapshot": "Ontbreekt in de volledige bron",
  "distribution.issue.import.mass_withdrawal": "Veel woningen ontbreken in deze bron",
  "distribution.issue.import.empty_feed": "Lege bron; er wordt niets ingetrokken",
  "distribution.issue.import.apply_failed": "Toepassen mislukt",
  "distribution.issue.import.no_input": "Geen bestand of adres",
  "distribution.issue.fetch.http_status": "Bron gaf een foutstatus",
  "distribution.issue.fetch.failed": "Ophalen mislukt",
  "distribution.issue.parse.failed": "Bestand kon niet gelezen worden",

  "distribution.imports.title": "Imports",
  "distribution.imports.waiting": "{count, plural, one {# wacht op review} other {# wachten op review}}",
  "distribution.imports.count": "{count, plural, one {# run} other {# runs}}",

  "distribution.sources.title": "Bronnen",
  "distribution.sources.add": "Bron toevoegen",
  "distribution.sources.empty_title": "Nog geen importbron",
  "distribution.sources.empty_body": "Voeg een bron toe, zoals een Kyero-feed van een partner of een spreadsheet.",
  "distribution.sources.linked": "{count, plural, =0 {nog geen woningen gekoppeld} one {# woning gekoppeld} other {# woningen gekoppeld}}",
  "distribution.sources.bres_owns": "BRES beheert: {groups}",
  "distribution.sources.source_owns_all": "Bron beheert alle velden",
  "distribution.sources.default_rights": "Nieuwe woningen krijgen recht voor {rights}",
  "distribution.sources.no_default_rights": "Nieuwe woningen krijgen geen rechten",
  "distribution.sources.right_website": "Websiterecht",
  "distribution.sources.right_portal": "Portaalrecht",
  "distribution.sources.right_website_short": "website",
  "distribution.sources.right_portal_short": "portalen",
  "distribution.sources.paused": "Gepauzeerd",
  "distribution.sources.add_title": "Importbron toevoegen",
  "distribution.sources.add_body": "Een bron wijzigt niets zonder dry-run en jouw akkoord.",
  "distribution.sources.add_submit": "Bron toevoegen",
  "distribution.sources.name": "Naam",
  "distribution.sources.adapter": "Formaat",
  "distribution.sources.transport": "Aanlevering",
  "distribution.sources.url": "Adres (https)",
  "distribution.sources.url_invalid": "Gebruik een volledig https-adres.",
  "distribution.sources.hosts": "Toegestane hosts",
  "distribution.sources.hosts_hint": "Gescheiden door komma's. Leeg betekent alleen {host}.",
  "distribution.sources.rights": "Rechten voor nieuwe woningen",
  "distribution.sources.rights_hint": "Alleen aanvinken als de bron je die rechten schriftelijk geeft.",
  "distribution.sources.authority": "Bronhouder per veldgroep",
  "distribution.sources.authority_hint": "Bij Bron neemt een import wijzigingen over. Bij BRES blijven jouw waarden staan.",
  "distribution.sources.owner_source": "Bron",
  "distribution.sources.owner_bres": "BRES",
  "distribution.sources.created": "Bron {name} toegevoegd",

  "distribution.adapter.kyero_v3": "Kyero XML v3",
  "distribution.adapter.bres_json_v1": "BRES JSON v1",
  "distribution.adapter.bres_csv_v1": "BRES CSV v1",

  "distribution.adapter_hint.kyero_v3": "Volledige feed volgens de Kyero-importspecificatie.",
  "distribution.adapter_hint.bres_json_v1": "Eigen geversioneerd contract van BRES.",
  "distribution.adapter_hint.bres_csv_v1": "Spreadsheet met de BRES-kolommen.",

  "distribution.transport.upload": "Bestand uploaden",
  "distribution.transport.https_pull": "Ophalen via https",

  "distribution.group.identity": "Referentie en soort",
  "distribution.group.price": "Prijs",
  "distribution.group.status": "Status",
  "distribution.group.facts": "Kenmerken",
  "distribution.group.location": "Locatie",
  "distribution.group.texts": "Teksten",
  "distribution.group.media": "Foto's",

  "distribution.dry_run.action": "Dry-run starten",
  "distribution.dry_run.title": "Dry-run starten",
  "distribution.dry_run.lead": "Een dry-run wijzigt niets. Je ziet eerst per woning wat er zou veranderen.",
  "distribution.dry_run.drop": "Sleep een bestand hierheen",
  "distribution.dry_run.choose": "Bestand kiezen",
  "distribution.dry_run.other_file": "Ander bestand",
  "distribution.dry_run.too_large": "Bestand is groter dan 60 MB.",
  "distribution.dry_run.accepts_kyero_v3": "XML-bestand, maximaal 60 MB",
  "distribution.dry_run.accepts_bres_json_v1": "JSON-bestand, maximaal 60 MB",
  "distribution.dry_run.accepts_bres_csv_v1": "CSV-bestand, maximaal 60 MB",
  "distribution.dry_run.pull_title": "BRES haalt het bestand op",
  "distribution.dry_run.pull_hosts": "Toegestane hosts: {hosts}",
  "distribution.dry_run.submit": "Dry-run starten",
  "distribution.dry_run.started": "Dry-run gestart",

  "distribution.runs.title": "Runs",
  "distribution.runs.col_status": "Status",
  "distribution.runs.col_source": "Bron",
  "distribution.runs.col_changes": "Verschillen",
  "distribution.runs.col_items": "Records",
  "distribution.runs.col_file": "Bestand",
  "distribution.runs.col_created": "Gestart",
  "distribution.runs.empty_title": "Nog geen runs",
  "distribution.runs.empty_body": "Start een dry-run bij een bron om de verschillen te zien.",
  "distribution.runs.col_run": "Run",
  "distribution.runs.all_statuses": "Alle",
  "distribution.runs.all_sources": "Alle bronnen",
  "distribution.runs.clear": "Filters wissen",
  "distribution.runs.empty_filtered_title": "Geen runs met dit filter",
  "distribution.runs.empty_filtered_body": "Wis de filters om alle runs te zien.",

  "distribution.run_status.fetching": "Bestand ophalen",
  "distribution.run_status.diffing": "Verschillen bepalen",
  "distribution.run_status.awaiting_review": "Wacht op review",
  "distribution.run_status.applying": "Wordt toegepast",
  "distribution.run_status.applied": "Toegepast",
  "distribution.run_status.failed": "Mislukt",
  "distribution.run_status.rejected": "Afgewezen",
  "distribution.run_status.superseded": "Vervangen",

  "distribution.trigger.manual": "Handmatig",
  "distribution.trigger.schedule": "Gepland",
  "distribution.trigger.upload": "Upload",

  "distribution.count.create": "{count} nieuw",
  "distribution.count.update": "{count} gewijzigd",
  "distribution.count.unchanged": "{count} ongewijzigd",
  "distribution.count.withdraw": "{count} ontbreekt",
  "distribution.count.quarantine": "{count} in quarantaine",
  "distribution.count.conflict": "{count, plural, one {# conflict} other {# conflicten}}",
  "distribution.count.applied": "{count} toegepast",
  "distribution.count.failed": "{count} mislukt",

  "distribution.action.create": "Nieuw",
  "distribution.action.update": "Gewijzigd",
  "distribution.action.unchanged": "Ongewijzigd",
  "distribution.action.withdraw": "Ontbreekt in bron",
  "distribution.action.quarantine": "Quarantaine",
  "distribution.action.conflict": "Conflict",

  "distribution.run.crumb": "Importrun",
  "distribution.run.title": "Dry-run {source}",
  "distribution.run.title_loading": "Importrun",
  "distribution.run.processing": "De worker verwerkt het bestand. Deze pagina ververst vanzelf.",
  "distribution.run.failed_title": "Deze run is mislukt",
  "distribution.run.errors": "Fouten",
  "distribution.run.warnings_title": "Let op",
  "distribution.run.applied_title": "{count, plural, one {# wijziging toegepast} other {# wijzigingen toegepast}}",
  "distribution.run.applied_body": "{failed, plural, =0 {Niets mislukt.} one {# mislukt.} other {# mislukt.}} Akkoord door {by} op {time}.",
  "distribution.run.rejected_title": "Afgewezen",
  "distribution.run.rejected_body": "Er is niets gewijzigd. Start een nieuwe dry-run als de bron is aangepast.",
  "distribution.run.rejected_toast": "Run afgewezen",
  "distribution.run.summary": "Samenvatting",
  "distribution.run.facts": "Gegevens",
  "distribution.run.trigger": "Aanleiding",
  "distribution.run.started": "Gestart",
  "distribution.run.hash": "Bronbestand (SHA-256)",
  "distribution.run.snapshot": "Omvang bron",
  "distribution.run.snapshot_complete": "Volledige momentopname",
  "distribution.run.snapshot_partial": "Gedeeltelijk",
  "distribution.run.bres_owns": "BRES is bronhouder voor",
  "distribution.run.filter": "Filter op soort",
  "distribution.run.withdraw_note": "Woningen die ontbreken worden nooit verwijderd. Na jouw akkoord gaat alleen het aanbod op ingetrokken.",
  "distribution.run.apply": "Toepassen",
  "distribution.run.reject": "Afwijzen",
  "distribution.run.reject_title": "Deze dry-run afwijzen?",
  "distribution.run.reject_body": "Er wordt niets toegepast. De run blijft zichtbaar als afgewezen.",
  "distribution.run.reject_confirm": "Run afwijzen",
  "distribution.run.records": "{count, plural, one {# record} other {# records}}",

  "distribution.items.label": "Records in deze run",
  "distribution.items.col_item": "Record",
  "distribution.items.col_action": "Soort",
  "distribution.items.col_details": "Wijzigingen en meldingen",
  "distribution.items.col_decision": "Besluit",
  "distribution.items.external": "ext. {id}",
  "distribution.items.create": "Wordt een nieuwe woning in BRES.",
  "distribution.items.unchanged": "Geen verschillen.",
  "distribution.items.withdraw": "Ontbreekt in de volledige bron. Alleen na jouw akkoord gaat het aanbod op ingetrokken; de woning blijft bestaan.",
  "distribution.items.issues": "Meldingen",
  "distribution.items.empty_title": "Niets voor dit filter",
  "distribution.items.empty_body": "Er zijn geen records voor dit filter.",
  "distribution.items.search": "Records zoeken",
  "distribution.items.search_placeholder": "Referentie, externe ID of plaats",
  "distribution.items.clear": "Filters wissen",
  "distribution.items.none_title": "Geen records",
  "distribution.items.none_body": "Deze run bevat geen records.",

  "distribution.decision.pending_apply": "Wordt toegepast",
  "distribution.decision.pending_withdraw": "Wacht op akkoord",
  "distribution.decision.pending_blocked": "Niet toepasbaar",
  "distribution.decision.not_applied": "Niet toegepast",
  "distribution.decision.accepted": "Geaccepteerd",
  "distribution.decision.rejected": "Afgewezen",
  "distribution.decision.applied": "Toegepast",
  "distribution.decision.skipped": "Overgeslagen",

  "distribution.decide.label": "Besluiten voor selectie",
  "distribution.decide.accept": "Accepteren",
  "distribution.decide.reject": "Afwijzen",
  "distribution.decide.accepted": "{count, plural, =0 {Niets geaccepteerd} one {# record geaccepteerd} other {# records geaccepteerd}}",
  "distribution.decide.rejected": "{count, plural, =0 {Niets afgewezen} one {# record afgewezen} other {# records afgewezen}}",
  "distribution.decide.skipped": "{count, plural, one {# overgeslagen: quarantaine en conflicten kun je niet accepteren.} other {# overgeslagen: quarantaine en conflicten kun je niet accepteren.}}",

  "distribution.diff.label": "Veldverschillen",
  "distribution.diff.empty": "leeg",
  "distribution.diff.becomes": "wordt",
  "distribution.diff.blocked_lock": "vergrendeld in BRES",
  "distribution.diff.blocked_authority": "BRES is bronhouder",

  "distribution.field.reference": "Referentie",
  "distribution.field.kind": "Soort",
  "distribution.field.offer_amountMinor": "Prijs",
  "distribution.field.offer_currency": "Valuta",
  "distribution.field.offer_priceOnRequest": "Prijs op aanvraag",
  "distribution.field.offer_status": "Status",
  "distribution.field.bedrooms": "Slaapkamers",
  "distribution.field.bathrooms": "Badkamers",
  "distribution.field.builtM2": "Bebouwd",
  "distribution.field.plotM2": "Perceel",
  "distribution.field.yearBuilt": "Bouwjaar",
  "distribution.field.features": "Kenmerken",
  "distribution.field.energyRating": "Energielabel",
  "distribution.field.locality": "Plaats",
  "distribution.field.municipality": "Gemeente",
  "distribution.field.province": "Provincie",

  "distribution.apply.title": "Dry-run toepassen",
  "distribution.apply.withdrawals_skipped": "{count, plural, one {# intrekvoorstel zonder akkoord blijft staan} other {# intrekvoorstellen zonder akkoord blijven staan}}",
  "distribution.apply.blocked": "{count, plural, one {# record in quarantaine of conflict gaat niet mee} other {# records in quarantaine of conflict gaan niet mee}}",
  "distribution.apply.hash_note": "Alleen als het bronbestand sinds de dry-run niet is veranderd:",
  "distribution.apply.decide_first_title": "Beslis eerst over de intrekvoorstellen",
  "distribution.apply.decide_first": "{count, plural, one {# intrekvoorstel wacht nog.} other {# intrekvoorstellen wachten nog.}} Bij zoveel ontbrekende woningen accepteer of wijs je elk voorstel apart af.",
  "distribution.apply.confirm_withdrawals": "{count, plural, one {Ik bevestig # intrekking} other {Ik bevestig # intrekkingen}}",
  "distribution.apply.nothing": "Er is niets om toe te passen.",
  "distribution.apply.submit": "{count, plural, =0 {Toepassen} one {# wijziging toepassen} other {# wijzigingen toepassen}}",
  "distribution.apply.done": "{count, plural, =0 {Niets toegepast} one {# wijziging toegepast} other {# wijzigingen toegepast}}",
  "distribution.apply.failed": "{count, plural, one {# mislukt; zie de melding bij het record} other {# mislukt; zie de meldingen bij de records}}",
  "distribution.apply.rejected": "{count, plural, one {# record afgewezen, blijft ongewijzigd} other {# records afgewezen, blijven ongewijzigd}}",

  "distribution.apply_error.import.source_changed_title": "Bron is veranderd",
  "distribution.apply_error.import.source_changed": "Het bronbestand is gewijzigd sinds deze dry-run. BRES past deze run daarom niet toe. Start een nieuwe dry-run en beoordeel de verschillen opnieuw.",
  "distribution.apply_error.import.mass_withdrawal_unconfirmed_title": "Intrekkingen niet bevestigd",
  "distribution.apply_error.import.mass_withdrawal_unconfirmed": "Veel woningen ontbreken in de bron. Beslis per intrekvoorstel en bevestig de intrekkingen.",
  "distribution.apply_error.import.not_awaiting_review_title": "Run is al afgehandeld",
  "distribution.apply_error.import.not_awaiting_review": "Deze run is al toegepast of afgewezen. Ververs de pagina.",

  "distribution.progress.label": "Voortgang van de publicatie",
  "distribution.progress.step_snapshot": "Snapshot",
  "distribution.progress.step_build": "Build",
  "distribution.progress.step_checks": "Controles",
  "distribution.progress.step_live": "Live",
  "distribution.progress.state_done": "klaar",
  "distribution.progress.state_active": "bezig",
  "distribution.progress.state_waiting": "in de wachtrij",
  "distribution.progress.state_failed": "mislukt",
  "distribution.progress.state_todo": "nog niet begonnen",
  "distribution.progress.queued": "In de wachtrij bij de buildserver",
  "distribution.progress.running": "Bouwen, {duration}",
  "distribution.progress.done": "Live in {duration}",
  "distribution.progress.failed": "Mislukt; de vorige versie blijft live",
  "distribution.progress.superseded": "Ingehaald door een nieuwere publicatie",
  "distribution.progress.excluded": "{count, plural, one {# woning uitgesloten} other {# woningen uitgesloten}}",
  "distribution.progress.details": "Details",
  "distribution.progress.dismiss": "Voortgang sluiten",

  "distribution.history.title": "Geschiedenis",
  "distribution.history.channel": "Kanaal",
  "distribution.history.all_channels": "Alle kanalen",
  "distribution.history.show": "Toon",
  "distribution.history.show_all": "Alles",
  "distribution.history.show_builds": "Builds",
  "distribution.history.show_withdrawals": "Spoedintrekkingen",
  "distribution.history.withdrawal_title": "{reference} van de website gehaald",
  "distribution.history.empty_title": "Nog niets gepubliceerd",
  "distribution.history.empty_body": "Elke publicatie verschijnt hier met status, duur en controles.",
  "distribution.history.empty_filtered_title": "Niets voor dit filter",
  "distribution.history.empty_filtered_body": "Kies een ander kanaal of toon alles.",
  "distribution.history.clear": "Alles tonen",

  "distribution.rejections.title": "{count, plural, one {# afwijzing} other {# afwijzingen}}",
  "distribution.rejections.no_reason": "Geen reden doorgegeven",

  "distribution.plan.title": "Bij toepassen",
  "distribution.plan.creates": "{count, plural, one {nieuwe woning} other {nieuwe woningen}}",
  "distribution.plan.updates": "{count, plural, one {woning bijgewerkt} other {woningen bijgewerkt}}",
  "distribution.plan.withdrawals": "{count, plural, one {aanbod ingetrokken} other {aanbiedingen ingetrokken}}",
  "distribution.plan.no_rights": "Alleen eigenaren en beheerders passen imports toe."
}
